var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStars(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 99.244,
    height: 102.352,
    viewBox: "0 0 99.244 102.352",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_436",
    "data-name": "Group 436",
    transform: "translate(-397.709 -4278)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2590",
    "data-name": "Path 2590",
    d: "M212.188,121.62h-2.193a52.829,52.829,0,0,1-41.125,41.125v2.193a52.345,52.345,0,0,1,41.307,40.941h2.01a52.829,52.829,0,0,1,41.125-41.125v-2.193a52.372,52.372,0,0,1-41.125-40.941Z",
    transform: "translate(240.534 4174.473)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2591",
    "data-name": "Path 2591",
    d: "M131.888,74.113h.914A24.467,24.467,0,0,1,151.811,55.1v-.914A24.936,24.936,0,0,1,132.8,35h-.914A24.467,24.467,0,0,1,112.88,54.008v1.1A24.467,24.467,0,0,1,131.888,74.113Z",
    transform: "translate(284.829 4243)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2592",
    "data-name": "Path 2592",
    d: "M485.621,121.62h-.548a15.075,15.075,0,0,1-11.7,11.7v.548a15.075,15.075,0,0,1,11.7,11.7h.548a15.075,15.075,0,0,1,11.7-11.7v-.548A14.6,14.6,0,0,1,485.621,121.62Z",
    transform: "translate(-0.365 4174.473)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStars);
export default __webpack_public_path__ + "static/media/stars.5e7ef0683945a39ceeca3fc64f4e4f6d.svg";
export { ForwardRef as ReactComponent };